import { createFileRoute } from '@tanstack/react-router';
import { LegalShell } from '@/components/legal/LegalShell';
import { ContentProse } from '@/components/prose';
import termsMarkdown from '../content/legal/terms.md?raw';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalShell title="Terms of Service">
      <ContentProse source={termsMarkdown} />
    </LegalShell>
  );
}
